import { useState } from 'react';

import { SlideTransition } from 'modules/common/transition';

import { FooterRoot } from './Footer.Root';
import { FooterMessage } from './Footer.Message';
import { Missing } from './Missing';
import { Cancel } from './Cancel';

export const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <FooterRoot>
        <Missing isOpen={isOpen} setIsOpen={setIsOpen} />
        <Cancel />
      </FooterRoot>
      <SlideTransition visible={isOpen}>
        <FooterMessage>
          Возможно, вы ввели неверный номер телефона на предыдущем шаге.
          Проверьте номер. Если вы уверены, что номер введён правильно, а СМС не
          пришло в течение 15 минут, пожалуйста, обратитесь в нашу техподдержку.
        </FooterMessage>
      </SlideTransition>
    </>
  );
};
